import { create } from 'zustand';

export type AgentTokenStatus = 'idle' | 'loading' | 'ready' | 'error';

interface AgentSessionState {
  agentToken: string | null;
  status: AgentTokenStatus;
  refreshNonce: number;
  setAgentToken: (agentToken: string | null) => void;
  setStatus: (status: AgentTokenStatus) => void;
}

export const useAgentSessionStore = create<AgentSessionState>(set => ({
  agentToken: null,
  status: 'idle',
  refreshNonce: 0,
  setAgentToken: agentToken =>
    set(({ refreshNonce }) => ({
      agentToken,
      // Only bump when a token is minted so iframes remount on refresh, not on clear.
      refreshNonce: agentToken ? refreshNonce + 1 : refreshNonce,
      // Clearing the session returns status to idle so consumers do not keep
      // a stale ready/error from the previous org/mint.
      ...(agentToken ? {} : { status: 'idle' as const }),
    })),
  setStatus: status => set({ status }),
}));
